import { SelectModule } from './../select/select.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddParticipantModalComponent } from './add-participant-modal.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { FormsModule } from '@angular/forms';
import { CygovButtonModule } from '../cygov-button/cygov-button.module';

@NgModule({
  imports: [CommonModule, SvgIconModule, FormsModule, SelectModule, CygovButtonModule],
  declarations: [AddParticipantModalComponent],
  exports: [AddParticipantModalComponent],
})
export class AddParticipantModalModule {}
